import { render, staticRenderFns } from "./notification-permission.vue?vue&type=template&id=edfdfee8&scoped=true&"
import script from "./notification-permission.vue?vue&type=script&setup=true&lang=js&"
export * from "./notification-permission.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./notification-permission.vue?vue&type=style&index=0&id=edfdfee8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfdfee8",
  null
  
)

export default component.exports